const LEGACY_COOKIE_NAMES = [
	"_ga",
	"_gid",
	"_gat",
	"_gcl_au",
	"__hstc",
	"__hssc",
	"__hssrc",
	"hubspotutk",
	"messagesUtk",
];
const LEGACY_COOKIE_PREFIXES = [
	"_ga_",
	"_hjSession_",
	"_hjSessionUser_",
	"_hjid",
];

export function clearLegacyCookies() {
	const hostnameParts = window.location.hostname.split(".");
	const rootDomain =
		hostnameParts.length > 2
			? `.${hostnameParts.slice(-2).join(".")}`
			: `.${window.location.hostname}`;
	const domainAttrs = [
		rootDomain,
		`.${window.location.hostname}`,
		window.location.hostname,
		"",
	];

	const existingNames = document.cookie
		.split(";")
		.map((c) => c.split("=")[0].trim())
		.filter(Boolean);

	const toDelete = existingNames.filter(
		(name) =>
			LEGACY_COOKIE_NAMES.includes(name) ||
			LEGACY_COOKIE_PREFIXES.some((prefix) => name.startsWith(prefix)),
	);

	toDelete.forEach((name) => {
		domainAttrs.forEach((domain) => {
			document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${
				domain ? `; domain=${domain}` : ""
			}`;
		});
	});
}
